import React, { Component } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

import './ftue.css';
import { ASSETS_URL } from '../../Settings';

export default class FtueToast extends Component {

    render() {
        let message = this.props.ftueMessage;
        if (!message) return <div id={'No FTUE Toast'} />
        return <>
            <ToastContainer className="p-3" position={'bottom-center'}
                            id={'toaster'}
                            style={{zIndex: 201, bottom: '70px'}}
                            onClick={this.props.closeToast}
            >
                <Toast onClose={this.props.closeToast}
                       className={'ftue-toast'}
                >
                    <Toast.Header closeButton={true}
                                  closeVariant={'white'}
                                  className={'ftue-toast-header'}>
                        <div>
                            <img
                            src={`${ASSETS_URL}textures/Texture00157.png`}
                            className="ftue-hexbot rounded me-2"
                            alt="AIHelper"
                        />
                        </div>
                        {/* <strong className="me-auto">FTUE</strong> */}
                        {/* <small>11 mins ago</small> */}
                    </Toast.Header>
                    <Toast.Body className={'ftue-toast-body'}>
                        <span dangerouslySetInnerHTML={{ __html: message }}/>
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>;
    }

}
